'use client';

import seedrandom from 'seedrandom';
import {useSetGalleryImageId} from 'src/hooks/useGalleryImage';
import roundNumber from 'src/utils/roundNumber';
import getImageUrl from 'src/utils/getImageUrl';
import FadingImage from '../FadingImage';
import BaseButton from '../BaseButton';

const imagesSizes = '(max-width: 1024px) 33vw, (max-width: 1600px) 25vw, 500px';

type Props = {
  place: Place;
};

const ListicleGallery = ({place}: Props) => {
  const setActiveImage = useSetGalleryImageId();

  const images = (place.images || []).slice(0, 4);

  return (
    <div className="flex mb-7 w-full justify-center relative max-sm:justify-start max-w-[1600px]">
      {images.map((image, index) => {
        const randomNumber = seedrandom(image.path)();
        const rotation = roundNumber(randomNumber * 6 - 3, 2);
        const aspectRatio = Math.min(image.width / image.height, 1.7);

        return (
          <div
            className="hover-container h-[240px] max-[1600px]:h-[15vw] max-lg:h-[19vw] -ml-6 first:ml-0 max-lg:nth-4:hidden max-sm:nth-3:hidden max-sm:ml-0 max-sm:first:ml-[3vw] max-sm:first:w-[72vw] max-sm:first:h-auto max-sm:nth-2:absolute max-sm:nth-2:right-[3vw] max-sm:nth-2:-bottom-[2vw]"
            key={image.path}
            style={{
              transform: `rotate(${rotation}deg) translateY(${rotation * 3}px)`,
              aspectRatio: String(aspectRatio)
            }}
          >
            <BaseButton
              onPress={() => setActiveImage(image._id, place._id)}
              className="relative rounded-2xl w-full h-full overflow-visible"
            >
              <FadingImage
                fill
                alt={place.name}
                src={getImageUrl(image.path, 'thumb')}
                sizes={
                  index === 0 ? `(max-width: 640px) 80vw, ${imagesSizes}` : `(max-width: 640px) 25vw, ${imagesSizes}`
                }
                className="rounded-2xl shadow-[0_1px_3px_rgb(23_10_37_/_0.2),0_3px_16px_rgb(23_10_37_/_0.1),0_30px_60px_rgb(23_10_37_/_0.15)] hover:scale-105 active:scale-95 transition-transform object-cover"
              />
            </BaseButton>
          </div>
        );
      })}
    </div>
  );
};

export default ListicleGallery;
